import getApp from '../firebase'
import { useCallback } from 'react'

const useDeleteDocument = (collection: string) =>
  useCallback(async (id: string) => getApp().firestore().collection(collection).doc(id).delete(), [collection])
export default useDeleteDocument
